module.exports = __webpack_public_path__ + "img/help.14f87140.png";